import { call, put, select, takeEvery } from 'redux-saga/effects';

import { getAuthHeader } from '../../app/selectors';
import keycloak from '../../services/Keycloak';

import { authSlice } from './authSlice';

export const getHeader = () => `${keycloak?.tokenParsed?.typ} ${keycloak?.token}`;

const extractRoleName = (givenRole: string) => {
    if (!givenRole) {
        return givenRole;
    }
    let role = givenRole;

    const first = role.indexOf('-');

    role = role.substring(first < 0 ? 0 : first + 1);

    const last = role.lastIndexOf('-');

    role = role.substring(0, last < 0 ? role.length : last);

    return role;
};

export function* watchSetTokensSaga() {
    const header: string = yield call(getHeader);
    const existHeader: string = yield select(getAuthHeader);

    if (header !== existHeader) {
        yield put(authSlice.actions.setAuthHeader(header));
        const userProfile: ReturnType<typeof keycloak.loadUserProfile> = yield call(keycloak.loadUserProfile);

        // Роли из keycloak'а будут приходить с префиксом и суфиксом. Напр. pkrim-OCExpert-prod.
        // Нужно привести имена ролей к именам ролей приложения
        let roles: string[] = [];

        // Изменяем источник ролей на realm_access
        const givenRoles = keycloak?.tokenParsed?.realm_access?.roles;

        console.log(givenRoles);

        if (givenRoles) {
            roles = givenRoles.map((value) => extractRoleName(value));
        }

        yield put(
            authSlice.actions.setProfile({
                ...userProfile,
                roles,
            }),
        );

        const userInfo: ReturnType<typeof keycloak.loadUserInfo> = yield call(keycloak.loadUserInfo);

        yield put(authSlice.actions.setInfo(userInfo));

        yield put(authSlice.actions.setIsAuthenticated(true));
    }
}

export function* authSaga() {
    yield takeEvery(authSlice.actions.setTokens, watchSetTokensSaga);
}
